import React from 'react';

import Label from 'ui-library/bs/Label';
import TextArea from 'ui-library/bs/TextArea';
import {TextAreaChangeEvent} from 'util/Types';

const ROW_COUNT = 3;

export interface CommentBoxProps {
  comment: string | undefined;
  onChange: (e: TextAreaChangeEvent) => void;
}

const CommentBox = ({comment, onChange}: CommentBoxProps): JSX.Element => (
  <div>
    <Label>Comments</Label>
    <TextArea placeholder="Leave a comment..." rows={ROW_COUNT} value={comment} onChange={onChange} />
  </div>
);

export default CommentBox;
